import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./Components/Auth0/Login/loginSlice";
import addToCartReducer from "./Components/Home/addToCartSlice";

export const store = configureStore({
  reducer: {
    loginReducer: loginReducer,
    addToCart: addToCartReducer,
  },
});
